import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Poem from '../../components/Poem';
import Product from '../../components/Product';
import ProjectImage from '../../components/ProjectImage';
import getProjects from '../../utils/getProjects';

class Project extends Component {
  state = {
    index: null,
    nextSlug: null,
    prevSlug: null,
  };

  componentWillMount() {
    const { data } = this.props;
    const projects = getProjects(data.allContentfulProject.edges);
    const lastProject = projects.length - 1;

    const thisSlug = data.contentfulProject.slug;
    const thisIndex = projects.findIndex(({ slug }) => thisSlug === slug);

    this.setState({
      index: thisIndex + 1,
      nextSlug:
        thisIndex !== lastProject
          ? projects[thisIndex + 1].slug
          : projects[0].slug,
      prevSlug:
        thisIndex !== 0
          ? projects[thisIndex - 1].slug
          : projects[lastProject].slug,
    });
  }

  componentDidMount() {
    const { data } = this.props;
    const { buyLink, poem } = data.contentfulProject;
    window.addEventListener('keyup', this.onKeyPress);
    if (!buyLink && poem) {
      document.body.style.overflow = 'hidden';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyPress);
    document.body.style.overflow = 'auto';
  }

  onKeyPress = e => {
    const key = e.keyCode ? e.keyCode : e.which;
    if (key === 39) this.goToNext();
    if (key === 37) this.goToPrev();
  };

  goToNext = (state) => {
    const { nextSlug } = this.state;
    navigateTo({
      pathname: `/${nextSlug}`,
      state,
    });
  };

  goToPrev = () => {
    const { prevSlug } = this.state;
    navigateTo({
      pathname: `/${prevSlug}`,
    });
  };

  handleClick = () => {
    this.goToNext();
  }

  render() {
    const { data } = this.props;
    const { index } = this.state;
    const { buyLink, client, images, slug, title, poem } = data.contentfulProject;

    const hasImages = images && images.length > 0;
    const isProduct = !!buyLink;
    const isPoem = !isProduct && poem && poem.length;
    const isImage = !isProduct && !isPoem && hasImages;
    const imagesSlug = hasImages ? `/${slug}/images/` : null;

    // const scrolling = history.location.state && history.location.state.scrolling;

    return (
      <div key={slug}>
        <Header
          anchor={slug}
          background
          buy={buyLink}
          client={client}
          id={index}
          slug={imagesSlug}
          title={title}
          total={data.allContentfulProject.edges.length}
        />
        <div
          onClick={this.handleClick}
          style={{ 
            cursor: 'e-resize',
            height: '100vh',
            width: '100vw'
          }}
        >
          {isProduct && (
            <Product
              images={images}
              stanzas={poem}
            />
          )}

          {isPoem && (
            <Poem 
              goToNext={this.goToNext}
              goToPrev={this.goToPrev}
              stanzas={poem} 
            />
          )}

          {isImage && (
            <ProjectImage src={images[0].asset.file.url} />
          )}
        </div>
      </div>
    );
  }
}

export default Project;

Project.propTypes = {
  data: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Project/index.jsx